/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-11-22 18:15:10
 * @modify date 2023-11-22 18:15:10
 * @desc [description]
 */


import { useTranslation } from "react-i18next";
import { View } from "react-native";
import ListTable from "../../base/table/listTable";
import ContentBox from "../../base/tamplate/ContentBox";
import StorageData, { actionMenus, tableHeaders } from "./StorageData";
import { ContentContainerProps } from "../../../interfaceTypes/ContentsProps";

interface StorageMgmtProps extends ContentContainerProps {
    clickActionMenu: Function;
    clickRow: Function;
    fetchData: any;
    currentPage : number;
    pageCount: number;
    headers: any;
    tableData: StorageData[];
    totalItemCount: number;
    refreshYn: boolean;
}

export default function StorageMgmt(props:StorageMgmtProps) {
    const { t } = useTranslation();

    return (
        <ContentBox title={t("STORAGE_TITLE")} subtitle={t("STORAGE_SUBTITLE")} infoText={props.infoText} infoError={props.infoError}>
            <View style={{backgroundColor: "#fff"}}>
                <ListTable
                    id={"storageManagement"}
                    actionMenus={actionMenus}
                    actionMenuClickCb={props.clickActionMenu}
                    searchBarYn={true}
                    searchBarPlaceholder={t("STORAGE_SEARCH_BAR_PLACEHOLDER_TEXT")}
                    pageYn={true}
                    rowCheckYn={false}
                    rowClickCb={props.clickRow}
                    fetchDataCb={props.fetchData}
                    currentPage={props.currentPage}
                    pageCount={props.pageCount}
                    pageSize={20}
                    tableHeaders={tableHeaders}
                    tableData={props.tableData}
                    totalItemCount={props.totalItemCount}
                    detailYn={true}
                    refreshYn={props.refreshYn}
                    canLoadYn={true}
                />
            </View>
        </ContentBox>
    )
}